import { DBaseStateSetSub } from "./d-base-state-set-sub";

export interface DBaseStateSetBlinker extends DBaseStateSetSub {}
